/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddEditShowBodyBody,
    ArrangementBodyBody,
    ArrangementPositionsResponseResponse,
    ArrangementResponseResponse,
    ArrangementsListResponseResponse,
    GenerateVerificationScript200,
    GenerateVerificationScriptBody,
    GetShowsParams,
    RequestStatusResponseResponse,
    ShowCreateSuccessResponseResponse,
    ShowSuccessResponseResponse,
    ShowsSuccessResponseResponse,
    SyncShowICal200,
    UpsertArrangementPositionBodyBody,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Add new show
 */
export const addShow = (addEditShowBodyBody: AddEditShowBodyBody, signal?: AbortSignal) => {
    return customInstance<ShowCreateSuccessResponseResponse>({
        url: `/shows`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addEditShowBodyBody,
        signal,
    });
};

export const getAddShowMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addShow>>,
        TError,
        { data: AddEditShowBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addShow>>,
    TError,
    { data: AddEditShowBodyBody },
    TContext
> => {
    const mutationKey = ['addShow'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addShow>>,
        { data: AddEditShowBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return addShow(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddShowMutationResult = NonNullable<Awaited<ReturnType<typeof addShow>>>;
export type AddShowMutationBody = AddEditShowBodyBody;
export type AddShowMutationError = APIErrorResponseResponse;

/**
 * @summary Add new show
 */
export const useAddShow = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addShow>>,
        TError,
        { data: AddEditShowBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addShow>>,
    TError,
    { data: AddEditShowBodyBody },
    TContext
> => {
    const mutationOptions = getAddShowMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get shows matching the filters
 */
export const getShows = (params?: GetShowsParams, signal?: AbortSignal) => {
    return customInstance<ShowsSuccessResponseResponse>({
        url: `/shows`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetShowsQueryKey = (params?: GetShowsParams) => {
    return [`/shows`, ...(params ? [params] : [])] as const;
};

export const getGetShowsQueryOptions = <
    TData = Awaited<ReturnType<typeof getShows>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetShowsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getShows>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetShowsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShows>>> = ({ signal }) =>
        getShows(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getShows>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetShowsQueryResult = NonNullable<Awaited<ReturnType<typeof getShows>>>;
export type GetShowsQueryError = APIErrorResponseResponse;

/**
 * @summary Get shows matching the filters
 */

export function useGetShows<
    TData = Awaited<ReturnType<typeof getShows>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetShowsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getShows>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetShowsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get show by id
 */
export const getShow = (id: number, signal?: AbortSignal) => {
    return customInstance<ShowSuccessResponseResponse>({
        url: `/shows/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetShowQueryKey = (id?: number) => {
    return [`/shows/${id}`] as const;
};

export const getGetShowQueryOptions = <
    TData = Awaited<ReturnType<typeof getShow>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getShow>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetShowQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShow>>> = ({ signal }) =>
        getShow(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getShow>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetShowQueryResult = NonNullable<Awaited<ReturnType<typeof getShow>>>;
export type GetShowQueryError = APIErrorResponseResponse;

/**
 * @summary Get show by id
 */

export function useGetShow<
    TData = Awaited<ReturnType<typeof getShow>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getShow>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetShowQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit show
 */
export const editShow = (id: number, addEditShowBodyBody: AddEditShowBodyBody) => {
    return customInstance<ShowSuccessResponseResponse>({
        url: `/shows/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addEditShowBodyBody,
    });
};

export const getEditShowMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editShow>>,
        TError,
        { id: number; data: AddEditShowBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editShow>>,
    TError,
    { id: number; data: AddEditShowBodyBody },
    TContext
> => {
    const mutationKey = ['editShow'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editShow>>,
        { id: number; data: AddEditShowBodyBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return editShow(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditShowMutationResult = NonNullable<Awaited<ReturnType<typeof editShow>>>;
export type EditShowMutationBody = AddEditShowBodyBody;
export type EditShowMutationError = APIErrorResponseResponse;

/**
 * @summary Edit show
 */
export const useEditShow = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editShow>>,
        TError,
        { id: number; data: AddEditShowBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editShow>>,
    TError,
    { id: number; data: AddEditShowBodyBody },
    TContext
> => {
    const mutationOptions = getEditShowMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete show by id
 */
export const deleteShow = (id: number) => {
    return customInstance<RequestStatusResponseResponse>({ url: `/shows/${id}`, method: 'DELETE' });
};

export const getDeleteShowMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteShow>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteShow>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['deleteShow'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteShow>>, { id: number }> = (
        props,
    ) => {
        const { id } = props ?? {};

        return deleteShow(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteShowMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShow>>>;

export type DeleteShowMutationError = APIErrorResponseResponse;

/**
 * @summary Delete show by id
 */
export const useDeleteShow = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteShow>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<Awaited<ReturnType<typeof deleteShow>>, TError, { id: number }, TContext> => {
    const mutationOptions = getDeleteShowMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Sync iCal for a specific show
 */
export const syncShowICal = (id: number, signal?: AbortSignal) => {
    return customInstance<SyncShowICal200>({
        url: `/shows/${id}/ical-sync`,
        method: 'POST',
        signal,
    });
};

export const getSyncShowICalMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof syncShowICal>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof syncShowICal>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['syncShowICal'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncShowICal>>, { id: number }> = (
        props,
    ) => {
        const { id } = props ?? {};

        return syncShowICal(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type SyncShowICalMutationResult = NonNullable<Awaited<ReturnType<typeof syncShowICal>>>;

export type SyncShowICalMutationError = APIErrorResponseResponse;

/**
 * @summary Sync iCal for a specific show
 */
export const useSyncShowICal = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof syncShowICal>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof syncShowICal>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getSyncShowICalMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Calls an LLM (OpenRouter) to turn the venue's prompt into a JS snippet
plus the English error messages it can throw. Returns the generated
artifact without persisting; the admin reviews and saves through
editShow.

 * @summary Generate a verification script from a natural-language prompt
 */
export const generateVerificationScript = (
    id: number,
    generateVerificationScriptBody: GenerateVerificationScriptBody,
    signal?: AbortSignal,
) => {
    return customInstance<GenerateVerificationScript200>({
        url: `/shows/${id}/verification/generate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: generateVerificationScriptBody,
        signal,
    });
};

export const getGenerateVerificationScriptMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof generateVerificationScript>>,
        TError,
        { id: number; data: GenerateVerificationScriptBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof generateVerificationScript>>,
    TError,
    { id: number; data: GenerateVerificationScriptBody },
    TContext
> => {
    const mutationKey = ['generateVerificationScript'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof generateVerificationScript>>,
        { id: number; data: GenerateVerificationScriptBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return generateVerificationScript(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type GenerateVerificationScriptMutationResult = NonNullable<
    Awaited<ReturnType<typeof generateVerificationScript>>
>;
export type GenerateVerificationScriptMutationBody = GenerateVerificationScriptBody;
export type GenerateVerificationScriptMutationError = APIErrorResponseResponse;

/**
 * @summary Generate a verification script from a natural-language prompt
 */
export const useGenerateVerificationScript = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof generateVerificationScript>>,
        TError,
        { id: number; data: GenerateVerificationScriptBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof generateVerificationScript>>,
    TError,
    { id: number; data: GenerateVerificationScriptBody },
    TContext
> => {
    const mutationOptions = getGenerateVerificationScriptMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary List arrangements for a show
 */
export const getArrangements = (showId: number, signal?: AbortSignal) => {
    return customInstance<ArrangementsListResponseResponse>({
        url: `/shows/${showId}/arrangements`,
        method: 'GET',
        signal,
    });
};

export const getGetArrangementsQueryKey = (showId?: number) => {
    return [`/shows/${showId}/arrangements`] as const;
};

export const getGetArrangementsQueryOptions = <
    TData = Awaited<ReturnType<typeof getArrangements>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getArrangements>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetArrangementsQueryKey(showId);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArrangements>>> = ({ signal }) =>
        getArrangements(showId, signal);

    return { queryKey, queryFn, enabled: !!showId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getArrangements>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetArrangementsQueryResult = NonNullable<Awaited<ReturnType<typeof getArrangements>>>;
export type GetArrangementsQueryError = APIErrorResponseResponse;

/**
 * @summary List arrangements for a show
 */

export function useGetArrangements<
    TData = Awaited<ReturnType<typeof getArrangements>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getArrangements>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetArrangementsQueryOptions(showId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Create a new arrangement for a show
 */
export const createArrangement = (
    showId: number,
    arrangementBodyBody: ArrangementBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<ArrangementResponseResponse>({
        url: `/shows/${showId}/arrangements`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: arrangementBodyBody,
        signal,
    });
};

export const getCreateArrangementMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createArrangement>>,
        TError,
        { showId: number; data: ArrangementBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof createArrangement>>,
    TError,
    { showId: number; data: ArrangementBodyBody },
    TContext
> => {
    const mutationKey = ['createArrangement'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof createArrangement>>,
        { showId: number; data: ArrangementBodyBody }
    > = (props) => {
        const { showId, data } = props ?? {};

        return createArrangement(showId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateArrangementMutationResult = NonNullable<
    Awaited<ReturnType<typeof createArrangement>>
>;
export type CreateArrangementMutationBody = ArrangementBodyBody;
export type CreateArrangementMutationError = APIErrorResponseResponse;

/**
 * @summary Create a new arrangement for a show
 */
export const useCreateArrangement = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createArrangement>>,
        TError,
        { showId: number; data: ArrangementBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof createArrangement>>,
    TError,
    { showId: number; data: ArrangementBodyBody },
    TContext
> => {
    const mutationOptions = getCreateArrangementMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete an arrangement
 */
export const deleteArrangement = (showId: number, id: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/shows/${showId}/arrangements/${id}`,
        method: 'DELETE',
    });
};

export const getDeleteArrangementMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteArrangement>>,
        TError,
        { showId: number; id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteArrangement>>,
    TError,
    { showId: number; id: number },
    TContext
> => {
    const mutationKey = ['deleteArrangement'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteArrangement>>,
        { showId: number; id: number }
    > = (props) => {
        const { showId, id } = props ?? {};

        return deleteArrangement(showId, id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteArrangementMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteArrangement>>
>;

export type DeleteArrangementMutationError = APIErrorResponseResponse;

/**
 * @summary Delete an arrangement
 */
export const useDeleteArrangement = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteArrangement>>,
        TError,
        { showId: number; id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteArrangement>>,
    TError,
    { showId: number; id: number },
    TContext
> => {
    const mutationOptions = getDeleteArrangementMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get all seat positions for an arrangement
 */
export const getArrangementPositions = (showId: number, id: number, signal?: AbortSignal) => {
    return customInstance<ArrangementPositionsResponseResponse>({
        url: `/shows/${showId}/arrangements/${id}/positions`,
        method: 'GET',
        signal,
    });
};

export const getGetArrangementPositionsQueryKey = (showId?: number, id?: number) => {
    return [`/shows/${showId}/arrangements/${id}/positions`] as const;
};

export const getGetArrangementPositionsQueryOptions = <
    TData = Awaited<ReturnType<typeof getArrangementPositions>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getArrangementPositions>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetArrangementPositionsQueryKey(showId, id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArrangementPositions>>> = ({
        signal,
    }) => getArrangementPositions(showId, id, signal);

    return { queryKey, queryFn, enabled: !!(showId && id), ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getArrangementPositions>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetArrangementPositionsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getArrangementPositions>>
>;
export type GetArrangementPositionsQueryError = APIErrorResponseResponse;

/**
 * @summary Get all seat positions for an arrangement
 */

export function useGetArrangementPositions<
    TData = Awaited<ReturnType<typeof getArrangementPositions>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getArrangementPositions>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetArrangementPositionsQueryOptions(showId, id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Upsert a single seat position for an arrangement
 */
export const upsertArrangementPosition = (
    showId: number,
    id: number,
    seatId: number,
    upsertArrangementPositionBodyBody: UpsertArrangementPositionBodyBody,
) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/shows/${showId}/arrangements/${id}/positions/${seatId}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: upsertArrangementPositionBodyBody,
    });
};

export const getUpsertArrangementPositionMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof upsertArrangementPosition>>,
        TError,
        { showId: number; id: number; seatId: number; data: UpsertArrangementPositionBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof upsertArrangementPosition>>,
    TError,
    { showId: number; id: number; seatId: number; data: UpsertArrangementPositionBodyBody },
    TContext
> => {
    const mutationKey = ['upsertArrangementPosition'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof upsertArrangementPosition>>,
        { showId: number; id: number; seatId: number; data: UpsertArrangementPositionBodyBody }
    > = (props) => {
        const { showId, id, seatId, data } = props ?? {};

        return upsertArrangementPosition(showId, id, seatId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpsertArrangementPositionMutationResult = NonNullable<
    Awaited<ReturnType<typeof upsertArrangementPosition>>
>;
export type UpsertArrangementPositionMutationBody = UpsertArrangementPositionBodyBody;
export type UpsertArrangementPositionMutationError = APIErrorResponseResponse;

/**
 * @summary Upsert a single seat position for an arrangement
 */
export const useUpsertArrangementPosition = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof upsertArrangementPosition>>,
        TError,
        { showId: number; id: number; seatId: number; data: UpsertArrangementPositionBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof upsertArrangementPosition>>,
    TError,
    { showId: number; id: number; seatId: number; data: UpsertArrangementPositionBodyBody },
    TContext
> => {
    const mutationOptions = getUpsertArrangementPositionMutationOptions(options);

    return useMutation(mutationOptions);
};
